import AnimatedEmoji from "@components/AnimatedEmoji"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { CheckIcon, SparklesIcon } from "@heroicons/react/24/solid"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

const FREE_FILTERS_COUNT = 100

export default function GiftPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const perks = [
    t("pages.checkout.gift.perkExclusive"),
    t("pages.checkout.gift.perkUnlimited"),
    t("pages.checkout.gift.perkInstant"),
  ]

  const handleContinue = () => {
    navigate("/account/subscription", { replace: true })
  }

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="w-full space-y-8"
        >
          <div className="space-y-4">
            <AnimatedEmoji emoji="🎁" />

            <div className="space-y-1">
              <p className="text-sm font-semibold tracking-widest text-amber-400 uppercase">
                {t("pages.checkout.gift.tag")}
              </p>
              <h1 className="heading">{t("pages.checkout.gift.heading")}</h1>
            </div>

            <p className="text-text-secondary text-lg font-medium">
              {t("pages.checkout.gift.description")}
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="relative mx-auto max-w-sm overflow-hidden rounded-2xl border border-amber-400/30 bg-gradient-to-br from-amber-400/15 via-white/5 to-purple-400/15 px-6 py-7"
          >
            <div className="pointer-events-none absolute -top-10 -right-10 h-32 w-32 rounded-full bg-amber-400/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-12 -left-12 h-32 w-32 rounded-full bg-purple-400/20 blur-3xl" />

            <div className="relative space-y-4">
              <div className="flex items-center justify-center gap-2">
                <SparklesIcon className="h-5 w-5 text-amber-400" />
                <p className="text-sm font-semibold tracking-wide text-amber-300 uppercase">
                  {t("pages.checkout.gift.included")}
                </p>
                <SparklesIcon className="h-5 w-5 text-amber-400" />
              </div>

              <div className="space-y-1">
                <p className="text-5xl font-bold text-white">
                  {FREE_FILTERS_COUNT}
                </p>
                <p className="text-text-secondary text-base font-medium">
                  {t("pages.checkout.gift.filtersLabel")}
                </p>
              </div>

              <div className="space-y-2 border-t border-white/10 pt-4 text-left">
                {perks.map((perk) => (
                  <div key={perk} className="flex items-start gap-2">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
                    <p className="text-sm text-white/85">{perk}</p>
                  </div>
                ))}
              </div>

              <p className="border-t border-white/10 pt-4 text-sm font-medium text-white/70">
                {t("pages.checkout.gift.priceLine")}
              </p>
            </div>
          </motion.div>

          <Button
            arrow
            onClick={handleContinue}
            title={t("pages.checkout.gift.claim")}
          />
        </motion.div>
      </div>
    </Layout>
  )
}
